import { render, staticRenderFns } from "./RepxList.vue?vue&type=template&id=2977b97a"
import script from "./RepxList.vue?vue&type=script&lang=js"
export * from "./RepxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports